import { getRouteApi } from '@tanstack/react-router'

export const routeApi = getRouteApi('/_app/bsa/sars/$id/edit')
